// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodyS_className__i7HOx"};